<template>
    <b-modal id="modal-view-payroll" ref="modal-view-payroll" :title="title" no-enforce-focus scrollable size="lg">
      <!-- Header Company -->
      <HeaderCompany :consecutive="payrollData.consecutive"/>
      <a-divider/>
      <!-- Tabs -->
      <b-row>
        <b-col>
          <p>
            ><b>Total a pagar:</b> {{ currencyFormat(payrollData.totals.totalPayment) }}
          </p>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
            <a-tabs v-model="activeKey">
                <a-tab-pane key="1" tab="Fechas">
                    <b-row>
                        <b-col lg="6">
                          <span> > </span>
                          <b>Fecha inicio de liquidación:</b> {{ payrollData.payStartDate }}
                        </b-col>
                        <b-col lg="6">
                          <span> > </span>
                          <b>Fecha fin de liquidación:</b> {{ payrollData.payEndDate }}
                        </b-col>
                        <b-col lg="6">
                          <span> > </span>
                          <b>Fecha de pago:</b> {{ payrollData.payDate }}
                        </b-col>
                        <b-col lg="6">
                          <span> > </span>
                          <b>Método de pago:</b> {{ payrollData.employee.idPaymentMethod }}
                        </b-col>
                        <b-col lg="6" v-show="payrollData.employee.idBankAccountType !== null">
                          <span> > </span>
                          <b>Tipo de cuenta bancaria:</b> {{ payrollData.employee.idBankAccountType }}
                        </b-col>
                        <b-col lg="6" v-show="payrollData.employee.idBank !== null">
                          <span> > </span>
                          <b>Banco:</b> {{ payrollData.employee.idBank }}
                        </b-col>
                        <b-col lg="6" v-show="payrollData.employee.bankAccountNumber !== null">
                          <span> > </span>
                          <b>Número de cuenta:</b> {{ payrollData.employee.bankAccountNumber }}
                        </b-col>
                    </b-row>
                </a-tab-pane>
                <a-tab-pane key="2" tab="Devengados">
                    <template>
                      <b-row class="py-3" style="padding-left: 15px; padding-right: 15px;">
                          <b-table :fields="columns" :items="payrollData.accruals" head-variant="light" responsive foot-clone>
                            <template #cell(name)="accrual">
                              <span>{{ accrual.item.name }}</span>
                            </template>
                            <template #cell(value)="accrual">
                              <span>{{ accrual.item.value !== null ? currencyFormat(accrual.item.value) : '—' }}</span>
                            </template>
                            <template #cell(days)="accrual">
                              <span>{{ accrual.item.days !== null ? accrual.item.days : '—' }}</span>
                            </template>
                            <template #cell(hours)="accrual">
                              <span>{{ accrual.item.hours !== null ? accrual.item.hours : '—' }}</span>
                            </template>
                            <template #foot(name)="">
                              <b>Total</b>
                            </template>
                            <template #foot(value)="">
                              <b>{{ currencyFormat(payrollData.totals.totalsAccruals) }}</b>
                            </template>
                            <template #foot()="">
                              <span> — </span>
                            </template>
                          </b-table>
                      </b-row>
                    </template>
                </a-tab-pane>
                <a-tab-pane key="3" tab="Deducciones">
                    <template>
                      <b-row class="py-3" style="padding-left: 15px; padding-right: 15px;">
                          <b-table :fields="columns" :items="payrollData.deductions" head-variant="light" responsive foot-clone>
                            <template #cell(name)="deduction">
                              <span>{{ deduction.item.name }}</span>
                            </template>
                            <template #cell(value)="deduction">
                              <span>{{ deduction.item.value !== null ? currencyFormat(deduction.item.value) : '—' }}</span>
                            </template>
                            <template #cell(days)="deduction">
                              <span>{{ deduction.item.days !== null ? deduction.item.days : '—' }}</span>
                            </template>
                            <template #cell(hours)="deduction">
                              <span>{{ deduction.item.hours !== null ? deduction.item.hours : '—' }}</span>
                            </template>
                            <template #foot(name)="">
                              <b>Total</b>
                            </template>
                            <template #foot(value)="">
                              <b>{{ currencyFormat(payrollData.totals.totalsDeductions) }}</b>
                            </template>
                            <template #foot()="">
                              <span> — </span>
                            </template>
                          </b-table>
                      </b-row>
                    </template>
                </a-tab-pane>
            </a-tabs>
        </b-col>
      </b-row>
      <template #modal-footer>
        <b-button @click="$bvModal.hide('modal-view-payroll')" variant="secondary" size="sm" class="mr-2 mb-3 mt-3">Cancelar</b-button>
      </template>
    </b-modal>
</template>

<script>
import apiClient2 from '@/services/axios/v2.js'
import { currencyFormatPesos } from '@/services/utilities'
// import moment from 'moment'
import HeaderCompany from '@/components/custom/payroll/HeaderCompany.vue'

export default {
  name: 'ModalViewPayroll',
  props: {
    idPayroll: Number,
  },
  components: {
    HeaderCompany,
  },
  data() {
    return {
      activeKey: '1',
      title: '',
      columns: [
        {
          label: 'Devengado',
          key: 'name',
        },
        {
          label: 'Valor',
          key: 'value',
        },
        {
          label: 'Días',
          key: 'days',
        },
        {
          label: 'Horas',
          key: 'hours',
        },
      ],
      payrollData: {
        consecutive: null,
        payStartDate: '',
        payEndDate: '',
        payDate: '',
        employee: {
          id: null,
          idPaymentMethod: '',
          idBank: null,
          idBankAccountType: null,
          bankAccountNumber: '',
        },
        accruals: [],
        deductions: [],
        totals: {},
      },
      banks: [],
      bankAccountTypes: [],
      methodsPayment: [],
    }
  },
  created() {
    apiClient2.get('/banks').then((res) => {
      const { data } = res
      if (data.success) {
        this.banks = data.data
      }
    }).catch((err) => {
      console.log(err)
    })
    apiClient2.get('/payment-methods').then((res) => {
      const { data } = res
      if (data.success) {
        this.methodsPayment = data.data
      }
    }).catch((err) => {
      console.log(err)
    })
    apiClient2.get('/bank-account-types').then((res) => {
      const { data } = res
      if (data.success) {
        this.bankAccountTypes = data.data
      }
    }).catch((err) => {
      console.log(err)
    })
  },
  methods: {
    currencyFormat: function (money) {
      return currencyFormatPesos(money)
    },
    getPayroll() {
      apiClient2.get('/payrolls/' + this.idPayroll).then((res) => {
        const { data } = res
        if (data.success) {
          const keyMap = {
            idPaymentMethod: 'methodsPayment',
            idBank: 'banks',
            idBankAccountType: 'bankAccountTypes',
          }
          const keysEmployee = ['idPaymentMethod', 'idBank', 'idBankAccountType']
          keysEmployee.forEach((key) => {
            if (data.data.employee[key] !== null) {
              data.data.employee[key] = this[keyMap[key]].find((i) => i.id === data.data.employee[key]).name
            }
          })
          this.payrollData = data.data
        }
      }).catch((err) => {
        console.log(err)
      })
    },
  },
  watch: {
    idPayroll: function (newIdPayroll) {
      if (newIdPayroll) {
        this.getPayroll()
      }
    },
  },
}

</script>
